import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { createForm } from "@formily/core";
import { createSchemaField } from "@formily/react";
import {
  Form,
  FormItem,
  DatePicker,
  Checkbox,
  Cascader,
  Editable,
  Input,
  NumberPicker,
  Switch,
  Password,
  PreviewText,
  Radio,
  Reset,
  Select,
  Space,
  Submit,
  TimePicker,
  Transfer,
  TreeSelect,
  Upload,
  FormGrid,
  FormLayout,
  FormTab,
  FormCollapse,
  ArrayTable,
  ArrayCards,
} from "@formily/antd-v5";
import { Card, Slider, Rate, Button, UploadFile } from "antd";
import { DOMAIN } from "../../constants";

const Text: React.FC<{
  value?: string;
  content?: string;
  mode?: "normal" | "h1" | "h2" | "h3" | "p";
}> = ({ value, mode, content, ...props }) => {
  const tagName = mode === "normal" || !mode ? "div" : mode;
  return React.createElement(tagName, props, value || content);
};

const FileUpload = (props: any) => {
  const { t } = useTranslation();
  const [list, setList] = useState<UploadFile[]>([]);
  return (
    <Upload
      onChange={(file) => {
        setList(file);
      }}
      beforeUpload={() => false}
      multiple={true}
      fileList={list}
      //showUploadList={true}
    >
      <Button>{t("Upload a copy")}</Button>
    </Upload>
  );
};

const SchemaField = createSchemaField({
  components: {
    Space,
    FormGrid,
    FormLayout,
    FormTab,
    FormCollapse,
    ArrayTable,
    ArrayCards,
    FormItem,
    DatePicker,
    Checkbox,
    Cascader,
    Editable,
    Input,
    Text,
    NumberPicker,
    Switch,
    Password,
    PreviewText,
    Radio,
    Reset,
    Select,
    Submit,
    TimePicker,
    Transfer,
    TreeSelect,
    Upload,
    FileUpload,
    Card,
    Slider,
    Rate,
  },
});

const FormCreatePage = () => {
  const { t } = useTranslation();
  const form = useMemo(() => createForm(), []);

  return (
    <Form form={form} labelCol={6} wrapperCol={12}>
      <SchemaField>
        <SchemaField.String
          title="name"
          x-decorator="FormItem"
          x-component="Input"
          x-validator={[]}
          x-index={0}
          name="name"
        />
        <SchemaField.Number
          title="age"
          x-decorator="FormItem"
          x-component="NumberPicker"
          x-validator={[]}
          x-index={1}
          name="age"
        />
        <SchemaField.Number
          title="Rate"
          x-decorator="FormItem"
          x-component="Rate"
          x-validator={[]}
          default={3}
          x-index={2}
          name="rate"
        />
        <SchemaField.String
          name="idCard"
          title="ID"
          x-decorator="FormItem"
          x-component="Upload"
          x-component-props={{
            textContent: "Upload",
            action: `${DOMAIN}/api/main/upload-file`,
          }}
        />
      </SchemaField>
      <Submit
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        {t("Submit")}
      </Submit>
    </Form>
  );
};

export default FormCreatePage;
